module.exports = __webpack_public_path__ + "56285966f9c5e646d2b20058bd833532.svg";